import { render, staticRenderFns } from "./MediaNews.vue?vue&type=template&id=62ede032&scoped=true"
import script from "./MediaNews.vue?vue&type=script&lang=js"
export * from "./MediaNews.vue?vue&type=script&lang=js"
import style0 from "./MediaNews.vue?vue&type=style&index=0&id=62ede032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ede032",
  null
  
)

export default component.exports